import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from 'react';
import cx from 'classnames';
import s from './ColorSample.scss';
import { keyboardEvents } from '../../../constants';
import { Image, ImageResizeOptions } from '@wix/wix-ui-tpa/cssVars';
const DEFAULT_IMAGE_WIDTH = 50;
const DEFAULT_IMAGE_HEIGHT = 50;
export class ColorSample extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "ref", void 0);
    _defineProperty(this, "onMouseEnter", description => {
      if (this.isActive() && this.props.onMouseEnter) {
        this.props.onMouseEnter(description);
      }
    });
    _defineProperty(this, "onMouseLeave", e => {
      if (this.isActive() && this.props.onMouseLeave) {
        this.props.onMouseLeave(e);
      }
    });
    _defineProperty(this, "onChange", e => {
      if (this.isActive() && this.props.onChange) {
        var _this$props$onFocus, _this$props;
        (_this$props$onFocus = (_this$props = this.props).onFocus) == null || _this$props$onFocus.call(_this$props, e);
        this.props.onChange(e);
      }
    });
    _defineProperty(this, "onKeyDown", e => {
      const increase = [keyboardEvents.ARROW_RIGHT, keyboardEvents.ARROW_UP].map(_ => _.keyCode);
      const decrease = [keyboardEvents.ARROW_LEFT, keyboardEvents.ARROW_DOWN].map(_ => _.keyCode);
      const keyCode = e.charCode || e.keyCode;
      if (keyCode === keyboardEvents.ENTER.keyCode) {
        return this.onChange(e);
      }
      if (keyCode === keyboardEvents.TAB.keyCode) {
        return this.props.onKeyboardTabEvent && this.props.onKeyboardTabEvent();
      }
      if (!this.props.onKeyboardArrowEvent) {
        /* istanbul ignore next */
        return;
      }
      if (increase.includes(keyCode)) {
        this.props.onKeyboardArrowEvent(1);
      }
      if (decrease.includes(keyCode)) {
        this.props.onKeyboardArrowEvent(-1);
      }
    });
    _defineProperty(this, "onImageError", () => {
      var _this$ref$current;
      const isRenderedInDOM = ((_this$ref$current = this.ref.current) == null ? void 0 : _this$ref$current.offsetParent) !== null;
      if (isRenderedInDOM) {
        this.setState({
          imageError: true
        });
      }
    });
    _defineProperty(this, "focus", () => {
      this.ref.current.focus();
    });
    _defineProperty(this, "isActive", () => {
      return !this.props.isDisabled;
    });
    this.ref = /*#__PURE__*/React.createRef();
    this.state = {
      imageError: false
    };
  }
  componentDidUpdate(prevProps) {
    var _prevProps$image, _this$props$image;
    if (this.props.isFocused && !prevProps.isFocused) {
      this.props.shouldFocus && this.focus();
    }
    if (((_prevProps$image = prevProps.image) == null ? void 0 : _prevProps$image.src) !== ((_this$props$image = this.props.image) == null ? void 0 : _this$props$image.src)) {
      this.setState({
        imageError: false
      });
    }
  }
  render() {
    const {
      description,
      isSelected,
      isDisabled,
      rgbColorValue,
      image,
      colorSampleClassName,
      allowMultiple,
      isFocused
    } = this.props;
    const focusRingOnSiblingClassName = 'wixSdkShowFocusOnSibling';
    const showImage = (image == null ? void 0 : image.src) && !this.state.imageError;
    const classNames = cx(s.colorSample, focusRingOnSiblingClassName, {
      [s.disabled]: !this.isActive()
    }, colorSampleClassName);
    return /*#__PURE__*/React.createElement("label", {
      onMouseEnter: () => this.onMouseEnter(description),
      onMouseLeave: this.onMouseLeave,
      onFocus: () => this.onMouseEnter(description),
      onBlur: e => this.onMouseLeave(e),
      className: s.label,
      "data-hook": "color-sample"
    },
    /*#__PURE__*/
    //eslint-disable-next-line jsx-a11y/role-supports-aria-props
    React.createElement("input", {
      "aria-label": description,
      "aria-checked": isSelected,
      checked: isSelected,
      tabIndex: isFocused ? 0 : -1,
      className: s.input,
      disabled: isDisabled,
      onChange: this.onChange,
      onKeyDown: this.onKeyDown,
      ref: this.ref,
      type: allowMultiple ? 'checkbox' : 'radio'
    }), showImage ? /*#__PURE__*/React.createElement("span", {
      className: classNames,
      "data-hook": "color-sample-swatch"
    }, /*#__PURE__*/React.createElement(Image, {
      src: (image == null ? void 0 : image.src) ?? '',
      resize: ImageResizeOptions.cover,
      className: s.imageSwatch,
      fluid: true,
      shouldUseLQIP: true,
      alt: description,
      sourceHeight: (image == null ? void 0 : image.height) || DEFAULT_IMAGE_HEIGHT,
      sourceWidth: (image == null ? void 0 : image.width) || DEFAULT_IMAGE_WIDTH,
      onError: this.onImageError,
      "data-hook": "color-sample-image",
      encoding: "AVIF"
    })) : /*#__PURE__*/React.createElement("span", {
      style: {
        backgroundColor: rgbColorValue
      },
      className: classNames,
      "data-hook": "color-sample-color"
    }));
  }
}
//# sourceMappingURL=ColorSample.js.map